import {
  createFailAction,
  createStartAction,
} from '../redux-util/async-helpers';
import {
  GO_TO_PAGE,
  GO_TO_HIGHLIGHT,
  GO_TO_CFI,
  GO_TO_SEARCH_RESULT,
  CREATE_PAGE_VIEWER,
  PREV_PAGE,
  NEXT_PAGE,
} from './jigsaw-methods';
import { createReducer } from '../redux-util/general-helpers';
import { BOOK_NAV_REQUESTED, PAGE_READY } from './jigsaw-events';
import { withDestroyViewerReset } from '../reset-reducer-helpers';

const notLoading = () => false;
const loading = () => true;

const base = {
  [createStartAction(CREATE_PAGE_VIEWER).type]: loading,
  [BOOK_NAV_REQUESTED]: loading,
  [PAGE_READY]: notLoading,
};

[
  GO_TO_PAGE,
  GO_TO_HIGHLIGHT,
  GO_TO_SEARCH_RESULT,
  GO_TO_CFI,
  PREV_PAGE,
  NEXT_PAGE,
]
  .map(m => createFailAction(m).type)
  .forEach(k => (base[k] = notLoading));

export default withDestroyViewerReset(createReducer(true, base));
